<template>
	<ubi-page-container>
		<template v-slot:page-actions v-if="post">
			<el-button
					id="show-modal"
					@click="showModal = true"
					:disabled="!post"
					class="inline"
					v-loading="loadingButton"
			>{{ $t("posts.report.sendByEmail") }}
			</el-button>

			<!--v-if="browserContext.up('md')"-->
			<!--:to="{ name: 'post-edit', params: { post: post && post.id } }"-->
			<el-button
					@click="enregistrerPDF"
					type="primary"
					:disabled="!post"
					class="inline"
					v-loading="loadingButton"
			>{{ $t("posts.report.print") }}
			</el-button>
		</template>
		<ubi-panel>

			<router-link :to="{ name: 'posts' }">
				<el-link class="mb-3">{{ $t("posts.report.goBackToAdList") }}</el-link>
			</router-link>

			<!-- DEBUT MODAL-->
			<transition name="modal" v-if="showModal">
				<div class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container">
							<h2 class="modal-header">
								<slot name="header">
									{{ $t("posts.report.dialogTitle") }}
								</slot>
							</h2>

							<div class="modal-body">
								<slot name="body">
									{{ $t("posts.report.dialogEmail") }}
									<el-input v-model="emailDestinataire"></el-input>
									<br>
									<br>
									{{ $t("posts.report.dialogMessage") }}
									<el-input
											type="textarea"
											:rows="10"
											v-model="commentaireEmail">
									</el-input>
								</slot>
							</div>

							<div class="modal-footer">
								<slot name="footer">
									<el-button
											@click="showModal = false"
											class="inline"
									>{{ $t("posts.report.dialogCancel") }}
									</el-button>
									<el-button
											type="primary"
											:disabled="!emailDestinataire"
											class="inline"
											@click="sendByEmail"
											v-loading="loading"
									>{{ $t("posts.report.dialogSend") }}
									</el-button>
								</slot>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<!--FIN MODAL-->

			<div id="printDiv" class="divPanel" v-if="post">
				<!--DEBUT Photo-->
				<div>
					<h1>{{post.titre}}</h1>
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<div>
								<div id="blockPrincipal" class="text-center">
									<el-col>
										<h2 class="text-left"><span class="badge badge-info"
																	id="badgeReference">{{post.reference}}</span></h2>
									</el-col>
									<el-image id="imageAgrandit" v-if="post.photoPrincipale != null"
											  :src="this.post.photoPrincipale.url" fit="contain"></el-image>
									<div class="text-center" v-else>
										<ubi-icon class="no-photo" name="camera" size='250'/>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
					<!--DEBUT - MINATURE DE TOUTES LES PHOTO -->
					<el-row>
						<div class="demo-image__placeholder">
							<!--ICI ON PARCOURS TOUTES LES PHOTOS POUR LES AFFICHER EN MINATURE SOUS LA PHOTO PRINCIPALE.-->
							<a v-for="photo in post.photos" @click="agrandirPhoto(photo.url)" class="blockPhotos">
								<el-image :src='photo.url' style="max-height: 80px;width: 150px;"></el-image>
							</a>
							<!--(LA PHOTO PRINCIPALE EST LA PREMIERE MINATURE-->
						</div>
					</el-row>
					<br><br>

					<el-row :gutter="20" type="flex" justify="space-between" style="padding: -20px">
						<el-col :span="null">
							<h2 v-if="post.ville">{{ $t("posts.report.city") }} : {{post.ville}}</h2>
						</el-col>
						<el-col :span="null">
							<h2 v-if="post.prix">{{ $t("posts.report.price") }} : {{post.prix}} {{getDevise}}</h2>
						</el-col>
					</el-row>
					<!--FIN - MINATURE DE TOUTES LES PHOTO -->
				</div>

				<!--FIN Photo-->
				<h1 style="padding: 0 !important"></h1>

				<el-row :gutter="20" type="flex" justify="space-around" style="font-size: 120%">
					<el-col :span="null">
						<div>{{ $t("posts.report.yourAdHasBeDiffusedTo") }}</div>
					</el-col>
					<el-col :span="null">
						<div>{{ $t("posts.report.yourAdIsOnlineOn") }}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" type="flex" justify="space-around">
					<el-col :span="null">
						<h4 class="text-primary">{{ numberSentPortails }} {{ $t("posts.report.portals") }}</h4>
					</el-col>
					<el-col :span="null">
						<h4 class="text-success">{{ numberOnlinePortails }} {{ $t("posts.report.portals") }}</h4>
					</el-col>
				</el-row>

				<h1></h1>

				<!--DEBUT Block information-->
				<div id="reportsBlock">
					<el-row>
						<h2 align="center">{{ $t("posts.report.reportDate") }} {{currentDate}} :</h2> <br>
					</el-row>
					<el-row>
						<el-col :span="12" id="leftBlock">
							<el-row :gutter="20" type="flex" justify="space-between"
									v-for="(diffusionAnnonce, index) in diffusionAnnonces"
									v-if="index < diffusionAnnonces.length/2">
								<el-col>
									{{diffusionAnnonce.diffuseurName}} : <span
										v-html="onlineProofText(diffusionAnnonce)"></span>
								</el-col>
							</el-row>
						</el-col>
						<el-col style="padding-left: 20px" :gutter="20" :span="12" align="right">
							<el-row :gutter="20" type="flex" justify="space-between"
									v-for="(diffusionAnnonce, index) in diffusionAnnonces"
									v-if="index >= diffusionAnnonces.length/2">
								<el-col>
									{{diffusionAnnonce.diffuseurName}} : <span
										v-html="onlineProofText(diffusionAnnonce)"></span>
								</el-col>
							</el-row>
						</el-col>
					</el-row>

				</div>
				<br>
				<ubi-card >
					<el-row>
						{{ $t("posts.report.definition") }} : <br><br>
						<ul>
							<li>
								<strong class="text-success">{{ $t("posts.report.online") }}</strong> : {{ $t("posts.report.onlineText") }}
							</li>
							<li><strong class="text-primary">{{ $t("posts.report.sent") }}</strong> : {{ $t("posts.report.diffusedText") }}
							</li>
						</ul>
					</el-row>
				</ubi-card>

			</div>
		</ubi-panel>

	</ubi-page-container>
</template>

<script>
import { PostMixin } from '../posts/posts'
import UbiPanel from '../../components/Panel.vue'
import ElButton from '../../components/Button.vue'
import { sendEmail } from '../../services/email'
import html2pdf from 'html2pdf.js'
import moment from 'moment'
import { getDiffusionAnnonceByAnnonce, getPortals } from '@/services/portals'
import UbiCardContainer from '../../components/CardContainer.vue'

export default {
  name: 'AttendanceReports',
  components: { UbiCardContainer, ElButton, UbiPanel },
  inject: ['browserContext'],
  mixins: [PostMixin],
  data () {
    return {
      loading: false,
      loadingButton: false,
      photoAgrandit: null,
      photoPrincipale: null,
      showModal: false,
      emailDestinataire: null,
      commentaireEmail: this.$t('posts.report.dialogMessagePlaceholder'),
      post: null,
      diffusionAnnonces: []
    }
  },
  computed: {
    currentDate () {
      return moment().format('DD/MM/YYYY')
    },
    numberOnlinePortails () {
      return this.diffusionAnnonces.filter(diffusionAnnonce => diffusionAnnonce.onlineProof).length
    },
    numberSentPortails () {
      return this.diffusionAnnonces.filter(diffusionAnnonce => diffusionAnnonce.lastSentAt).length
    },
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    }
  },
  async mounted () {
    const activePortals = []
    const filter = { active: true, page: 1, limit: 150 }
    const portals = (await getPortals(filter)).list
    portals.forEach(p => activePortals.push(p.diffuseurId))
    this.diffusionAnnonces = await getDiffusionAnnonceByAnnonce(this.$route.params.post)
    this.diffusionAnnonces = this.diffusionAnnonces.filter(da => activePortals.includes(da.diffuseur))
    if (this.diffusionAnnonces.type === 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      return false
    }
  },
  methods: {
    onlineProofText (diffusionAnnonce) {
      let statusText = ''
      if (diffusionAnnonce.lastSentAt === null) {
        statusText = "<span class='text-primary'> - </span>"
      } else if (diffusionAnnonce.onlineProof) {
        statusText = "<a href='" + diffusionAnnonce.urlOnPortal + "' target='_blank'><span class='text-success'>" + this.$t('posts.report.online') + '</span></a>'
      } else {
        statusText = "<span class='text-primary'>" + this.$t('posts.report.sent') + '</span>'
      }
      return statusText
    },
    async enregistrerPDF () {
      window.scrollTo(0, 0)
      const opt = {
        filename: this.$t('posts.report.pdfName') + '.pdf',
        pagebreak: { mode: 'avoid-all' },
        html2canvas: { useCORS: true, scale: 2, allowTaint: true },
        jsPDF: {
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4',
          putOnlyUsedFonts: true,
          compress: true,
          precision: 0.5
        }
      }
      const element = document.getElementById('printDiv')
      await html2pdf().set(opt).from(element).save()
    },
    agrandirPhoto (picture) {
      document.getElementById('imageAgrandit').src = picture
      window.scrollTo(0, 0)
    },
    async sendByEmail () {
      window.scrollTo(0, 0)
      this.loading = true

      const opt = {
        pagebreak: { mode: 'avoid-all' },
        html2canvas: { useCORS: true, allowTaint: true },
        jsPDF: { format: 'a4', putOnlyUsedFonts: 'true', compress: 'true', precision: 0.5 }
      }

      const element = document.getElementById('printDiv')
      html2pdf().set(opt).from(element).outputPdf('blob').then(async (pdf) => {
        // handle your result here...
        const self = this
        const reader = new FileReader()
        // TODO : Les constantes ne sont pas utilisées, ça ne marchera pas
        // const logo = processEnvConfig.VUE_APP_IMAGE_FILIGRANE_MAIL
        // const content = '<div style="width: 700px; margin: auto;"> <div style="background-color: #255662; height: 140px; width: 700px; margin-bottom: 50px"> <img style="width: 350px; margin-top: 6%; margin-left: 29%" src="' + logo + '"> </div><p style="font-family: Dosis, Arial, Helvetica, sans-serif; font-size: large;text-align: center;">' + self.commentaireEmail + '</p> </div>'
        // content.outerHTML
        reader.readAsDataURL(pdf)
        reader.onloadend = async function () {
          const base64data = reader.result.replace(/^data:.+;base64,/, '')
          const mailData = {
            to: self.emailDestinataire,
            subject: self.$t('posts.report.emailSubject', { title: self.post.titre }),
            content: self.commentaireEmail,
            attachments: [{
              name: self.$t('posts.report.emailAttachmentFirstPart') + self.post.reference + '.pdf',
              content: base64data
            }]
          }

          const response = await sendEmail(mailData)
          if (response.type == 'error') {
            this.$message({ message: this.$t('error.found'), type: 'error' })
            self.loading = false
            return false
          }
          self.$message(response)
          self.loading = false
          self.showModal = false
        }
      })
    }
  }
}
</script>

<style>
	.divPanel {
		padding: 3%;
		background-color: white;
	}

	#printDiv {
	}

	#leftBlock {
		border-right-style: solid;
		border-color: #00b4cc;
		border-width: 1px;
	}

	#reportsBlock {
		/*box-shadow: 1px 1px 12px #DCDCDC;*/
		padding: 0 2% 2% 2%;
		background-color: white;
	}

	.blockPhotos {
		width: 150px;
		height: 80px;
		display: inline-block;
		margin-left: 3px;
	}

	#blockPrincipal {
		width: 100%;
		max-height: 350px;
	}

	#imageAgrandit {
		height: 300px;
		width: auto;
	}

	#badgeReference {
		font-size: 25px;
		margin-top: 15px;
		margin-left: 10px;
		position: absolute;
		z-index: 2;
		border: solid 2px;
	}

	/*DEBUT POPUP ENVOYER ANNONCE*/
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		display: table;
		transition: opacity .3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 600px;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
	}

	.modal-body {
		margin: 20px 0;
	}

	.modal-default-button {
		float: right;
	}

	/*
	 * The following styles are auto-applied to elements with
	 * transition="modal" when their visibility is toggled
	 * by Vue.js.
	 *
	 * You can easily play with the modal transition by editing
	 * these styles.
	 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	/*FIN POPUP ENVOYER ANNONCE*/
</style>
